import React from 'react'

const BetsPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold mb-6">Active Bets</h1>
      <p>Browse and place bets on various markets.</p>
    </div>
  )
}

export default BetsPage